<template>
  <layout>
    <rdkm-title>
      {{ $t('Причины временной недоступности донора') }}
      <user-accessible routerName="InaccessibilityReasonsEdit">   
        <router-link tag="span" to="/inaccessibilityReasons/add">
          <b-button class="float-right" right size="sm" variant="primary">
            <font-awesome-icon icon="plus" /> {{ $t('Добавить') }}
          </b-button>
        </router-link>
      </user-accessible>
    </rdkm-title>
    <div class="tile">
      <rdkm-grid :state="query">
        <grid-column name="code" :title="$t('Код')" cell="edit-cell"  width="200"></grid-column>
        <grid-column name="name" :title="$t('Причина')"></grid-column>
        <grid-column name="DELETE" :cell="isEditAndDeleteAccessible() ? 'delete-cell' : ''"></grid-column>
      </rdkm-grid>
    </div>
  </layout>
</template>

<script>
import Grid from '../../components/grid/Grid.vue';
import GridColumn from '../../components/grid/GridColumn.vue';
import RouteHelper from "@/helpers/route.helper";

export default {
  name: 'InaccessibilityDonors',
  props: ['query'],
  components: {
    'rdkm-grid': Grid,
    'grid-column': GridColumn,
  },
  methods: {
    isEditAndDeleteAccessible: function() {        
      return RouteHelper.isRouteNameAccessible(this.$auth.user(), 'InaccessibilityReasonsEdit');
    }
  }
};
</script>
